<template>
  <div class="container internal-section">
    <LoadingComponent v-if="programmeDetailsStore.isLoading" class="loader" />
    <div v-else-if="programme" class="row justify-between q-col-gutter-md">
      <div class="col-12 col-md-8">
        <div class="q-gutter-md">
          <div class="programme-card">
            <div class="secondary-background card-header">
              <div class="row justify-between q-col-gutter-md">
                <div
                  class="col-12 col-sm-8 col-md-9 column justify-between"
                  :class="{ 'justify-center text-center': $q.screen.lt.md }"
                >
                  <h1 class="title q-pb-sm">
                    {{ getName(programme) }}
                    <q-chip outline color="primary" style="border-width: 2px">{{
                      getType(programme)
                    }}</q-chip>
                    <q-icon
                      v-if="programme.is_featured"
                      name="workspace_premium"
                      color="accent"
                      size="32px"
                      class="cursor-pointer"
                    >
                      <q-tooltip
                        anchor="top middle"
                        self="bottom middle"
                        max-width="280px"
                        class="text-body2 shadow-4"
                      >
                        {{ $t('program_details.featured_tooltip') }}
                      </q-tooltip>
                    </q-icon>
                  </h1>

                  <div class="q-gutter-y-md q-gutter-x-sm">
                    <q-btn
                      type="a"
                      size="md"
                      @click="openURL(programme.website)"
                      rounded
                      no-caps
                      color="accent"
                      text-color="primary"
                      icon="language"
                      :label="$t('program_details.visit_btn')"
                    />
                    <q-btn
                      :label="$t('program_details.lead_btn')"
                      :icon="fabSlideshare"
                      no-caps
                      rounded
                      color="accent"
                      text-color="primary"
                      @click="interestModal = true"
                    />
                    <q-btn
                      v-if="!favoriteProgrammeStore.isFavorite(programme.id)"
                      size="lg"
                      flat
                      round
                      color="accent"
                      icon="favorite_outline"
                      @click="addToFavorite"
                    >
                      <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
                        <strong>{{ $t('programs.add_fav') }}</strong>
                      </q-tooltip>
                    </q-btn>

                    <q-btn
                      v-else
                      size="lg"
                      flat
                      round
                      color="accent"
                      icon="favorite"
                      @click="removeFromFavorite"
                    >
                      <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
                        <strong>{{ $t('programs.remove_fav') }}</strong>
                      </q-tooltip>
                    </q-btn>
                  </div>
                </div>

                <div
                  class="col-12 col-sm-4 col-md-3 flex justify-end"
                  :class="{ 'justify-center text-center': $q.screen.lt.md }"
                >
                  <q-avatar size="150px" class="bg-white">
                    <q-img
                      :alt="getName(programme)"
                      style="height: 80px; width: 160px"
                      :src="getPhoto(programme)"
                    />
                  </q-avatar>
                </div>
              </div>
            </div>
            <div class="content" v-html="getDescription(programme)"></div>
          </div>
          <div
            class="info-card"
            v-if="isMscProgramme(programme, type) && programme.disciplines.length > 0"
          >
            <div class="title">
              {{ $t('program_details.flows') }}
            </div>
            <div class="content">
              {{ $t('program_details.flows_desc') }}
              <ul>
                <li v-for="(discipline, index) in getMscDisciplines(programme)" :key="index">
                  {{ discipline }}
                </li>
              </ul>
            </div>
          </div>
          <div class="row yellow-bottom-card info-card">
            <div
              class="col-12"
              :class="
                programme.collaborations.length > 0 || programme.collab_en_institutions.length > 0
                  ? 'col-md-6'
                  : 'col-md-12'
              "
            >
              <div class="title">
                {{ $t('program_details.organization') }}
              </div>
              <div class="content">
                <q-list class="q-pa-none">
                  <q-item class="q-px-none">
                    <q-item-section>
                      <q-item-label>{{ $t('program_details.university') }}:</q-item-label>
                      <q-item-label caption lines="1">{{ getUniName(programme) }}</q-item-label>
                    </q-item-section>
                  </q-item>
                  <q-item class="q-px-none">
                    <q-item-section>
                      <q-item-label>{{ $t('program_details.school') }}:</q-item-label>
                      <q-item-label caption lines="1">{{ getSchoolName(programme) }}</q-item-label>
                    </q-item-section>
                  </q-item>
                  <q-item class="q-px-none">
                    <q-item-section>
                      <q-item-label>{{ $t('program_details.department') }}:</q-item-label>
                      <q-item-label caption lines="1"
                        >{{ getDepartmentName(programme) }}
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </div>
            </div>

            <div
              class="col-12 col-md-6"
              v-if="
                programme.collaborations.length > 0 || programme.collab_en_institutions.length > 0
              "
            >
              <div v-if="collaborations.length > 0">
                <!-- Ο Τίτλος σου (μένει ίδιος) -->
                <div class="title">
                  {{ $t('program_details.gr_collaborating_institutes') }}
                </div>

                <!-- Η νέα λίστα με Quasar Components -->
                <q-list class="q-pt-sm">
                  <q-item v-for="(collab, index) in collaborations" :key="index" class="q-px-none">
                    <q-item-section>
                      <q-item-label
                        class="text-body2"
                        :class="{ 'text-weight-medium': collab.has_department }"
                      >
                        {{ isGreek ? collab.uni_gr : collab.uni_en }}
                      </q-item-label>

                      <q-item-label v-if="collab.has_department" caption class="text-grey-8">
                        {{ isGreek ? collab.dep_gr : collab.dep_en }}
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </div>

              <div v-if="programme.collab_en_institutions.length > 0" class="q-pt-md">
                <div class="title">
                  {{ $t('program_details.en_collaborating_institutes') }}
                </div>
                <div
                  v-for="(institution, index) in programme.collab_en_institutions"
                  :key="index"
                  class="q-pt-md"
                  v-ripple
                >
                  <span>{{ institution }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="info-card bg-info">
            <div class="q-gutter-y-md">
              <div class="yellow-left-card row justify-between flex flex-center">
                <div class="col-6 title">
                  {{ $t('program_details.languages') }}
                </div>
                <div class="col-6 text-right">
                  {{ getLanguages(programme).join(', ') }}
                </div>
              </div>
              <div class="yellow-left-card row justify-between items-center">
                <div class="col-6 title q-pa-none">
                  {{ $t('program_details.topics') }}
                </div>
                <div class="col-6 text-right">
                  {{ getTopics(programme).join(', ') }}
                </div>
              </div>
              <div class="yellow-left-card row justify-between items-center">
                <div class="col-6 title q-pa-none">
                  {{ $t('program_details.study_modes') }}
                </div>
                <div class="col-6 text-right">
                  {{ getStudyModes(programme).join(', ') }}
                </div>
              </div>
              <div
                v-if="isMscProgramme(programme, type) || isBscProgramme(programme, type)"
                class="yellow-left-card row justify-between flex flex-center"
              >
                <div class="col-6 title">
                  {{ $t('program_details.semesters') }}
                </div>
                <div class="col-6 text-right">
                  {{ programme.semesters }} {{ $t('program_details.semesters_tag') }}
                </div>
              </div>
              <div
                v-if="programme.ects"
                class="yellow-left-card row justify-between flex flex-center"
              >
                <div class="col-6 title">
                  {{ $t('program_details.ects') }}
                </div>
                <div class="col-6 text-right">
                  {{ programme.ects }}
                </div>
              </div>
              <div
                v-if="isMscProgramme(programme, type) || isBscProgramme(programme, type)"
                class="yellow-left-card row justify-between flex flex-center"
              >
                <div class="col-6 title">
                  {{ $t('program_details.is_part_time') }}
                </div>
                <div class="col-6 text-right">
                  {{ programme.part_time ? $t('program_details.yes') : $t('program_details.no') }}
                </div>
              </div>
              <div
                v-if="
                  (isMscProgramme(programme, type) || isBscProgramme(programme, type)) &&
                  programme.part_time == true
                "
                class="yellow-left-card row justify-between flex flex-center"
              >
                <div class="col-6 title">
                  {{ $t('program_details.part_time_semesters') }}
                </div>
                <div class="col-6 text-right">
                  {{ programme.part_time_semesters }} {{ $t('program_details.semesters_tag') }}
                </div>
              </div>
              <div
                v-if="programme && isMscProgramme(programme, type)"
                class="yellow-left-card row justify-between flex flex-center"
              >
                <div class="col-6 title">
                  {{ $t('program_details.scholarship_offered') }}
                </div>
                <div class="col-6 text-right">
                  {{
                    programme.scholarship_offered
                      ? $t('program_details.yes')
                      : $t('program_details.no')
                  }}
                </div>
              </div>
              <div
                v-if="programme && isMscProgramme(programme, type) && getMasterType(programme)"
                class="yellow-left-card row justify-between flex flex-center"
              >
                <div class="col-6 title">
                  {{ $t('program_details.master_type') }}
                </div>
                <div class="col-6 text-right">
                  {{ getMasterType(programme) }}
                </div>
              </div>
              <div
                v-if="programme && isBscProgramme(programme, type) && getBachelorType(programme)"
                class="yellow-left-card row justify-between flex flex-center"
              >
                <div class="col-6 title">
                  {{ $t('program_details.bachelor_type') }}
                </div>
                <div class="col-6 text-right">
                  {{ getBachelorType(programme) }}
                </div>
              </div>
              <div
                v-if="programme && isShortTermProgramme(programme, type)"
                class="yellow-left-card row justify-between flex flex-center"
              >
                <div class="col-6 title">
                  {{ $t('program_details.duration_days') }}
                </div>
                <div class="col-6 text-right">
                  {{ programme.days }}
                </div>
              </div>
              <div
                v-if="isShortTermProgramme(programme, type)"
                class="yellow-left-card row justify-between flex flex-center"
              >
                <div class="col-6 title">
                  {{ $t('program_details.type') }}
                </div>
                <div class="col-6 text-right">
                  {{ getShortTermType(programme) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="q-gutter-md">
          <div class="info-card">
            <div class="title">
              {{ $t('program_details.calls') }}
            </div>
            <div class="content q-pt-xs q-gutter-y-md">
              <div
                v-if="programme.admission_type === 'panhellenic'"
                class="rounded-borders row q-pa-md bg-accent"
              >
                <i18n-t keypath="program_details.admission_info" tag="p" class="q-mb-none">
                  <template #link>
                    <a
                      href="https://studyingreece.edu.gr/bachelors/#Taughtingreek"
                      target="_blank"
                      class="text-primary text-weight-bold"
                      style="text-decoration: none"
                    >
                      studyingreece.edu.gr
                    </a>
                  </template>
                </i18n-t>
              </div>
              <div v-else class="q-gutter-y-md">
                <div v-if="programme.is_open">
                  <div v-for="call in programme.open_calls" :key="call.id" class="q-py-xs">
                    <div class="rounded-borders row q-pa-md bg-green-14">
                      <div v-if="call.target_languages?.length" class="language-badges">
                        <div v-for="lang in call.target_languages" :key="lang" class="flag-wrapper">
                          <img :src="getFlagUrl(lang)" :alt="lang" class="flag-img" />
                          <q-tooltip>{{ lang }}</q-tooltip>
                        </div>
                      </div>
                      <span class="col-12 text-primary column justify-between">
                        {{ getCallTitle(call) }}
                      </span>
                      <span class="col-12 text-primary column justify-between">
                        {{ getCallStartDate(call) }}
                        -
                        {{ getCallEndDate(call) }}
                      </span>
                      <div class="q-gutter-x-sm">
                        <q-btn
                          v-if="programme.apply_status && isEligibleForCall(call)"
                          no-caps
                          rounded
                          size="12px"
                          class="q-mt-sm pulse-btn"
                          text-color="green-14"
                          icon="library_add_check"
                          color="primary"
                          :label="$t('program_details.apply')"
                          @click="apply(call.id)"
                        >
                          <q-tooltip> {{ $t('program_details.click_apply') }}</q-tooltip>
                        </q-btn>
                        <q-btn
                          outline
                          no-caps
                          class="q-mt-sm"
                          rounded
                          size="12px"
                          icon="info"
                          text-color="primary"
                          :label="$t('program_details.view_call')"
                          :to="{
                            name: programme.apply_status
                              ? 'Internal Call Details'
                              : 'External Call Details',
                            params: { id: call.id, programmeId: call.programme_id },
                          }"
                        />
                      </div>
                    </div>
                    <CalendarRange
                      v-if="programme.open_calls.length === 1"
                      :start_date="new Date(call.start_date)"
                      :end_date="new Date(call.end_date)"
                    />
                  </div>
                </div>
                <div v-if="programme.future_calls.length > 0">
                  <div v-for="call in programme.future_calls" :key="call.id">
                    <div class="rounded-borders bg-accent q-pa-md">
                      <div v-if="call.target_languages?.length" class="language-badges">
                        <div v-for="lang in call.target_languages" :key="lang" class="flag-wrapper">
                          <img :src="getFlagUrl(lang)" :alt="lang" class="flag-img" />
                          <q-tooltip>{{ lang }}</q-tooltip>
                        </div>
                      </div>
                      <span class="col-12 text-primary column justify-between">
                        {{ getCallTitle(call) }}
                      </span>
                      <span class="col-12 text-primary column justify-between">
                        {{ getCallStartDate(call) }}
                        -
                        {{ getCallEndDate(call) }}
                      </span>
                      <div class="q-gutter-x-sm">
                        <q-btn
                          outline
                          no-caps
                          class="q-mt-sm"
                          rounded
                          size="12px"
                          icon="info"
                          text-color="primary"
                          :label="$t('program_details.view_call')"
                          :to="{
                            name: programme.apply_status
                              ? 'Internal Call Details'
                              : 'External Call Details',
                            params: { id: call.id, programmeId: call.programme_id },
                          }"
                        />
                      </div>
                    </div>
                    <CalendarRange
                      v-if="!programme.is_open && programme.future_calls.length == 1"
                      :start_date="new Date(call.start_date)"
                      :end_date="new Date(call.end_date)"
                    />
                  </div>
                </div>
                <div
                  v-if="!programme.is_open && programme.future_calls.length === 0"
                  class="q-py-xs"
                >
                  <div class="rounded-borders bg-negative q-pa-md">
                    <span class="row text-white text-body1 q-pb-sm">
                      {{ $t('program_details.calls_not_found') }}
                    </span>
                    <div class="text-body2 text-grey-4 q-pb-sm" style="max-width: 400px">
                      {{ $t('program_details.notify_me_description') }}
                    </div>

                    <q-btn
                      :label="$t('program_details.notify_me_btn')"
                      icon="mail"
                      text-color="white"
                      rounded
                      no-caps
                      outline
                      size="sm"
                      @click="interestModal = true"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-card">
            <div class="header">
              <div class="title row items-center">
                {{ $t('program_details.tuition_fees') }}
                <q-icon
                  name="info_outline"
                  class="material-symbols-outlined q-ml-xs"
                  size="18px"
                  style="cursor: pointer"
                >
                  <q-tooltip anchor="top middle" self="bottom middle" max-width="260px">
                    {{ $t('program_details.tuition_fees_tooltip') }}
                  </q-tooltip>
                </q-icon>
              </div>
            </div>
            <div
              v-for="(fee, index) in getFees(programme)"
              :key="index"
              class="content"
              style="display: inline-flex; align-items: center; gap: 6px; font-size: 13px"
              v-html="fee"
            ></div>
          </div>
          <div class="detail-card">
            <div class="header">
              <div class="title">
                {{ $t('program_details.contact_info') }}
              </div>
            </div>
            <div class="content">
              <q-list>
                <q-item class="q-pa-none">
                  <q-item-section>
                    <q-item-label
                      ><span class="text-bold">{{ $t('program_details.city') }}:</span>
                      {{ getCity(programme) }}
                    </q-item-label>
                  </q-item-section>
                  <q-item-section avatar>
                    <q-btn
                      color="secondary"
                      flat
                      dense
                      round
                      icon="pin_drop"
                      @click="openURL(`http://maps.google.com/?q=${programme.city_en}`)"
                    />
                  </q-item-section>
                </q-item>
                <q-item class="q-pa-none">
                  <q-item-section>
                    <q-item-label
                      ><span class="text-bold">{{ $t('program_details.email') }}:</span>
                      {{ programme.email }}
                    </q-item-label>
                  </q-item-section>
                  <q-item-section avatar>
                    <q-btn
                      color="secondary"
                      flat
                      dense
                      round
                      icon="attach_email"
                      :href="`mailto:${programme.email}`"
                    />
                  </q-item-section>
                </q-item>
                <q-item class="q-pa-none">
                  <q-item-section>
                    <q-item-label
                      ><span class="text-bold">{{ $t('program_details.phone') }}:</span>
                      {{ programme.phone }}
                    </q-item-label>
                  </q-item-section>
                  <q-item-section avatar>
                    <q-btn
                      flat
                      dense
                      round
                      color="secondary"
                      :href="`tel:${programme.phone}`"
                      icon="phone"
                    />
                  </q-item-section>
                </q-item>
              </q-list>
            </div>
          </div>
        </div>
      </div>
      <InterestModal v-model="interestModal" :programme-id="props.id" />
    </div>
    <div v-else class="text-center text-primary text-h5 q-pa-xl">
      <p>Programme not found or failed to load.</p>
      <q-btn
        rounded
        no-caps
        color="secondary"
        text-color="primary"
        label="Retry"
        @click="programmeDetailsStore.initProgramme(props.id, props.type)"
      />
    </div>
  </div>
  <ApplicantSelectionModal
    v-if="authStore.isAuthenticated && authStore.isAgent"
    v-model="selectionModal"
    @selected="onApplicantSelected"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { openURL, useQuasar } from 'quasar'
import { useRoute, useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { useAuthStore } from 'stores/auth-store'
import { useFavoriteProgrammeStore } from 'stores/favorite_programme-store'
import { useProgrammeDetailsStore } from 'stores/programme_details-store'

import { useProgrammeLocale } from 'src/composables/programme/useProgrammeLocale'
import { useSeoMeta } from 'src/composables/useSeoMeta'
import { useProgrammeRoute } from 'src/composables/programme/useProgrammeRoute'
import { useLanguageFlags } from 'src/composables/useLanguageFlags'
import { useCallLocale } from 'src/composables/useCallLocale'
import { useApplicationEligibility } from 'src/composables/useApplicationEligibility'

import LoadingComponent from 'components/main/LoadingComponent.vue'
import CalendarRange from 'components/programme-details/CalendarRange.vue'
import InterestModal from 'components/main/InterestModal.vue'
import ApplicantSelectionModal from 'src/components/applicant/ApplicantSelectionModal.vue'

import type { FavoriteProgramme } from 'src/types/FavoriteProgramme'
import type { ProgrammeType } from 'src/types/Programme'

import { isMscProgramme, isShortTermProgramme, isBscProgramme } from 'src/utils/programmeTypeGuards'
import { fabSlideshare } from '@quasar/extras/fontawesome-v6'
import { useLocaleStore } from 'src/stores/locale-store'

const props = defineProps<{
  id: number
  type: ProgrammeType
}>()

defineOptions({
  async preFetch({ store, currentRoute, ssrContext, redirect }) {
    const storeInstance = useProgrammeDetailsStore(store)
    const id = Number(currentRoute.params.id)
    const type = currentRoute.params.type as ProgrammeType
    try {
      await storeInstance.initProgramme(id, type, ssrContext)
      await storeInstance.initCollabInstitutions(ssrContext)
    } catch {
      redirect({ name: 'Error Page' })
    }
  },
})

const { t } = useI18n()
const $q = useQuasar()
const callToApply = ref<number | null>(null)
const interestModal = ref(false)
const selectionModal = ref(false)

const programmeDetailsStore = useProgrammeDetailsStore()
const authStore = useAuthStore()
const favoriteProgrammeStore = useFavoriteProgrammeStore()
const localeStore = useLocaleStore()

const route = useRoute()
const router = useRouter()

const { isGreek } = storeToRefs(localeStore)
const { programme, collaborations } = storeToRefs(programmeDetailsStore)

const { getFlagUrl } = useLanguageFlags()
const { ensureEligibilityLoaded, isEligibleForCall } = useApplicationEligibility()
const {
  getName,
  getType,
  getDescription,
  getDescriptionMeta,
  getUniName,
  getDepartmentName,
  getSchoolName,
  getFees,
  getTopics,
  getPhoto,
  getLanguages,
  getCity,
  getStudyModes,
  getShortTermType,
  getMscDisciplines,
  getMasterType,
  getBachelorType,
} = useProgrammeLocale()

const { getCallTitle, getCallStartDate, getCallEndDate } = useCallLocale()
const { getTypeFromRouteParams } = useProgrammeRoute()

onMounted(async () => {
  await ensureEligibilityLoaded()
})

useSeoMeta({
  // Αν το currentProgram είναι null, επιστρέφει "Loading..."
  title: () => {
    const p = programme.value
    return p ? getName(p) : t('loading')
  },

  description: () => {
    const p = programme.value
    if (!p) return ''
    // Καθαρισμός από HTML tags αν το getDescription επιστρέφει HTML
    return getDescription(p)
      .replace(/<[^>]*>?/gm, '')
      .substring(0, 160)
  },

  image: () => {
    const p = programme.value
    return p ? getPhoto(p) : undefined
  },

  // Breadcrumbs: Δυναμικά ανάλογα με το πρόγραμμα
  breadcrumbs: () => {
    const p = programme.value
    const crumbs = [{ name: t('navbar.home'), url: '/' }]
    if (p) {
      crumbs.push({ name: t('navbar.programs'), url: '/programmes' })
      crumbs.push({ name: getName(p), url: route.fullPath })
    }
    return crumbs
  },

  schema: () => {
    const p = programme.value
    if (!p) return { type: 'WebPage' }

    return {
      type: 'EducationalOccupationalProgram',
      data: {
        name: getName(p),
        description: getDescriptionMeta(p).replace(/<[^>]*>?/gm, ''),
        identifier: p.id.toString(),
        educationalCredentialAwarded: getTypeFromRouteParams(),
        programMode: getStudyModes(p)[0],
        provider: {
          '@type': 'CollegeOrUniversity',
          name: getUniName(p),
        },
        // Προσθέτουμε keywords στο schema
        keywords: `${getName(p)}, ${getCity(p)}`,
        offers: {
          '@type': 'Offer',
          priceCurrency: 'EUR',
          price: p.tuition_fees_from || 0,
        },
      },
    }
  },
})

async function addToFavorite() {
  if (!programme.value) return
  if (!authStore.isAuthenticated) {
    authStore.openLoginModal($q.cookies, route.path)
    return
  }
  const favProgramme = {
    programme_id: programme.value.id,
  } as FavoriteProgramme
  await favoriteProgrammeStore.saveFavoriteProgramme(favProgramme)
}

async function removeFromFavorite() {
  if (!authStore.isAuthenticated) return
  if (!programme.value) return
  const favProgramme = favoriteProgrammeStore.favoriteProgrammes.find((fp) => {
    return fp.programme_id === programme.value!.id
  }) as FavoriteProgramme
  await favoriteProgrammeStore.deleteFavoriteProgramme(favProgramme.id)
}

async function apply(callId: number) {
  if (!authStore.isAuthenticated) {
    await router.push({
      name: 'Application Create',
      params: { id: callId, lang: route.params.lang || 'en' },
    })
  } else {
    if (authStore.isAgent) {
      selectionModal.value = true
      callToApply.value = callId
    }
    if (authStore.isApplicant)
      await router.push({
        name: 'Application Create',
        params: { id: callId, lang: route.params.lang || 'en' },
      })
    if (authStore.isSecretary)
      $q.notify({
        color: 'negative',
        message: 'You are signed in as Secretary, you cannot apply to program!',
        timeout: 2000,
      })
  }
}

const onApplicantSelected = async (uuid: string) => {
  authStore.setActingAs(uuid, $q.cookies)
  await router.push({
    name: 'Agent Applicant Application Create',
    params: { uuid: uuid, id: callToApply.value },
  })
}
</script>

<style lang="scss" scoped>
.programme-card {
  border-radius: 20px;
  overflow: hidden; // Για να κόβει σωστά και το header bg
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

  .card-header {
    padding: 20px;
    color: white;

    @media (max-width: 450px) {
      padding: 10px;
    }
  }

  .title {
    color: $primary;
    font-size: 22px;
    font-weight: 600;
  }

  .content {
    padding: 20px;
    text-align: justify;
  }
}
.language-badges {
  top: 10px;
  left: 15px;
  z-index: 10;
  display: flex;
  flex-direction: row;
  gap: 6px;
}
</style>
